import { GeneralStepConversationTopics, SharePermissions, TicketStages } from 'core/enums/common';

export const TicketStageOptions = {
	...TicketStages,
	all: Object.keys(TicketStages).length,
};

export const TicketSubStageOptions = {
	...GeneralStepConversationTopics,
	all: Object.keys(GeneralStepConversationTopics).length,
};

type TicketStageOptionsType = typeof TicketStageOptions;

type TicketSubStageOptionsType = typeof TicketSubStageOptions;

export type TicketStageOptionsValues = TicketStageOptionsType[keyof TicketStageOptionsType];

export type TicketSubStageOptionsValues =
	TicketSubStageOptionsType[keyof TicketSubStageOptionsType];

export interface IPermissionsInfo {
	permissionEnum: SharePermissions;
	label: string;
}

export interface IStagesInfo {
	stageEnum: TicketStageOptionsValues;
	label: string;
	isAvailable: boolean;
}

export interface IStagesInput {
	isUseCasesReady: boolean;
	isTestCasesReady: boolean;
	isNotificationsReady: boolean;
	isReportReady: boolean;
}

export interface ISubStagesInfo {
	subStageEnum: TicketSubStageOptionsValues;
	label: string;
}

export interface IShareOptions {
	permission: SharePermissions;
	stage: Array<TicketStageOptionsValues>;
	subStage: Array<TicketSubStageOptionsValues>;
}
